import { getDepartmentsByOrganization } from '@/lib/api/atendimento/departments'
import type { Department } from '@/lib/api/common/interfaces/department.interface'
import { getPipelines, SalesPipeline } from '@/lib/api/sales/pipelines-api'
import { getWallets, SalesWallet } from '@/lib/api/sales/wallets-api'
import { getSalesFlows, SalesFlow } from '@/lib/api/sales/flows-api'
import { getOrganizationUsers, OrganizationUser } from '@/lib/api/users/users-api'
import { useAuth } from '@/store/hooks'
import { useEffect, useState } from 'react'

export interface FlowRefData {
    loaded: boolean
    pipelines: SalesPipeline[]
    users: OrganizationUser[]
    wallets: SalesWallet[]
    departments: Department[]
    flows: SalesFlow[]
}

/** Cadastros que os passos e gatilhos referenciam (funis, usuários, setores...). */
export function useFlowRefData(): FlowRefData {
    const { user } = useAuth()
    const [data, setData] = useState<FlowRefData>({
        loaded: false,
        pipelines: [],
        users: [],
        wallets: [],
        departments: [],
        flows: [],
    })

    useEffect(() => {
        if (!user?.organizationId) return
        Promise.all([
            getPipelines(),
            getOrganizationUsers(),
            getWallets(),
            getDepartmentsByOrganization(user.organizationId),
            getSalesFlows(),
        ])
            .then(([pipelines, users, wallets, departments, flows]) => {
                setData({
                    loaded: true,
                    pipelines: pipelines.success && Array.isArray(pipelines.result) ? pipelines.result : [],
                    users: users.success && Array.isArray(users.result) ? users.result : [],
                    wallets: wallets.success && Array.isArray(wallets.result) ? wallets.result : [],
                    departments: departments.success && Array.isArray(departments.result) ? departments.result : [],
                    flows: flows.success && Array.isArray(flows.result) ? flows.result : [],
                })
            })
            .catch(() => setData(prev => ({ ...prev, loaded: true })))
    }, [user?.organizationId])

    return data
}

export function findStage(ref: FlowRefData, stageId: number | null | undefined) {
    if (!stageId) return null
    for (const pipeline of ref.pipelines) {
        const stage = pipeline.stages?.find(s => s.id === Number(stageId))
        if (stage) return { pipeline, stage }
    }
    return null
}
